module.exports = __webpack_public_path__ + "img/logo-gk.3ce3223e.png";